module.exports = __webpack_public_path__ + "static/media/icon-not-available.1b32d556.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/icon-not-available.svg
// module id = 1867
// module chunks = 0